"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../store/store");
var owa_session_store_1 = require("owa-session-store");
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
    userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
})(function IsInlinePreviewsDirty(state) {
    return (state.optionState.isEnabled !== null &&
        state.optionState.isEnabled !== state.userOptions.ShowInlinePreviews);
});
//# sourceMappingURL=isInlinePreviewsOptionDirty.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-inline-previews-option/lib/utils/isInlinePreviewsOptionDirty.js
// module id = 5096
// module chunks = 2